import { Profile } from "../shared/profile.model";

export class Comment {
  id: number;
  body: string;
  discussion: string;
  parents: string;
  children: string;
  upVoteCount: number;
  downVoteCount: number;
  replyCount: number;
  replyTo: string;
  author: Profile;
  panel: {
    member: boolean;
    credential: string;
  };
  voted: {
    upVote: boolean;
    downVote: boolean;
  };
  createdAt: string;
}
